import { deDE } from "@mui/material/locale";
import { createTheme } from "@mui/material/styles";
import { components } from "./overrides";
import { palette } from "./palette";
import { lxTypography, typography } from "./typography";

/**
 * The lexoffice Material-UI Theme.
 *
 * This is the default theme for all lexoffice application.
 * 
 * You may use the `LxScreenTheme` for convenience.
 *
 * @package Theme
 * @example
 *
import { lexofficeThemeMUI } from "@lxo-blocks/react";
...
<App>
 <StyledEngineProvider injectFirst>
   <ThemeProvider theme={lexofficeThemeMUI}>
     <CssBaseline />
     <MyLxoApp/>
   </ThemeProvider>
 </StyledEngineProvider>
</App>
 */
export const lexofficeThemeMUI = createTheme(
  {
    components,
    palette,
    typography: { ...typography, ...lxTypography },
  },
  deDE
);
